import React, { useState, useEffect } from 'react';

import { makeOptionList } from 'lib/commonLib';
import { getMediaTpCodeList } from 'lib/api/code';

import MbSelectbox from 'components/molecules/MbSelectbox';

let initList;

const MediaTpCodeFilter = ({
  label,
  value,
  name,
  getParam,
  params,
  optionLabelKey,
  optionValueKey,
  style,
}) => {
  const [index, setIndex] = useState(0);
  const [mediaTpCodeList, setMediaTpCodeList] = useState(initList);

  useEffect(() => {
    getMediaTpCodeList()
      .then((response) => {
        const temporaryVar = makeOptionList(
          response.data.data,
          'CODE_VAL',
          'CODE_ID'
        );
        setMediaTpCodeList(temporaryVar);
      })
      .catch((error) => {
        alert(error);
      });
  }, []);

  /**
   * 매체 카테고리 셀렉트 박스
   * @param {string} name
   * @param {*} value
   */
  const handleFilterChange = (name, index, value) => {
    let newParams;
    const handle = () => {
      newParams = {
        ...params,
        [name]: value,
      };
      setIndex(index);
      getParam(newParams);
    };

    handle();
  };

  return (
    <MbSelectbox
      label={label}
      name={name}
      itemindex={index}
      optionData={mediaTpCodeList}
      optionLabelKey={optionLabelKey}
      optionValueKey={optionValueKey}
      handleOnchange={handleFilterChange}
      icon={false}
      style={style}
    />
  );
};

export default MediaTpCodeFilter;
